import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import roCommon from './locales/ro/common.json';
import roAuth from './locales/ro/auth.json';
import roExpenses from './locales/ro/expenses.json';
import roImport from './locales/ro/import.json';
import roFilter from './locales/ro/filter.json';
import roAdmin from './locales/ro/admin.json';
import roDatabase from './locales/ro/database.json';
import roPhotos from './locales/ro/photos.json';
import roWorks from './locales/ro/works.json';
import roComments from './locales/ro/comments.json';
import roNotifications from './locales/ro/notifications.json';

import ruCommon from './locales/ru/common.json';
import ruAuth from './locales/ru/auth.json';
import ruExpenses from './locales/ru/expenses.json';
import ruImport from './locales/ru/import.json';
import ruFilter from './locales/ru/filter.json';
import ruAdmin from './locales/ru/admin.json';
import ruDatabase from './locales/ru/database.json';
import ruPhotos from './locales/ru/photos.json';
import ruWorks from './locales/ru/works.json';
import ruComments from './locales/ru/comments.json';
import ruNotifications from './locales/ru/notifications.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enExpenses from './locales/en/expenses.json';
import enImport from './locales/en/import.json';
import enFilter from './locales/en/filter.json';
import enAdmin from './locales/en/admin.json';
import enDatabase from './locales/en/database.json';
import enPhotos from './locales/en/photos.json';
import enWorks from './locales/en/works.json';
import enComments from './locales/en/comments.json';
import enNotifications from './locales/en/notifications.json';

export const i18n = i18next.createInstance();

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ro',
    supportedLngs: ['ro', 'ru', 'en'],
    ns: ['common', 'auth', 'expenses', 'import', 'filter', 'admin', 'database', 'photos', 'works', 'comments', 'notifications'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'forest-lang',
      caches: ['localStorage'],
    },
    lng: localStorage.getItem('forest-lang') || 'ro',
    resources: {
      ro: {
        common: roCommon,
        auth: roAuth,
        expenses: roExpenses,
        import: roImport,
        filter: roFilter,
        admin: roAdmin,
        database: roDatabase,
        photos: roPhotos,
        works: roWorks,
        comments: roComments,
        notifications: roNotifications,
      },
      ru: {
        common: ruCommon,
        auth: ruAuth,
        expenses: ruExpenses,
        import: ruImport,
        filter: ruFilter,
        admin: ruAdmin,
        database: ruDatabase,
        photos: ruPhotos,
        works: ruWorks,
        comments: ruComments,
        notifications: ruNotifications,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        expenses: enExpenses,
        import: enImport,
        filter: enFilter,
        admin: enAdmin,
        database: enDatabase,
        photos: enPhotos,
        works: enWorks,
        comments: enComments,
        notifications: enNotifications,
      },
    },
  });
